import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

export type statusType = string | {
  label: string;
  color: string;
  badge?: {
    label: string;
    color: string;
  };  tooltip?: string;
}

type columnType = 'status' | 'statusMultiple' | 'actionBtns' | 'elipsis' | 'link' | 'checkBox' | 'badge';


export interface Column {
  def: string;
  header: string;
  type?: columnType;
}

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})

export class TableComponent implements AfterViewInit, OnChanges {

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  isProgress: boolean = false;

  @Input() title: string;
  @Input() icone: string;
  @Input() displayedColumns: string[];
  @Input() columns: Column[];
  @Input() columnFilters: any[];
  @Input() data: any;
  @Input() filter: string;
  @Input() pageSizeOptions: number[];
  @Input() linkTableRow: string;
  @Input() activeRowClick: boolean = false;
  @Input() loading: boolean = false;
  @Input() compact: boolean = false;
  @Input() length: number = 0;
  @Input() pageSize: number = 10;
  @Input() pageIndex: number = 0;
  @Input() serverSidePagination: boolean = false;
  @Input() customSortColumns: string[] = [];
  @Input() rowTooltip?: string | ((row: any) => string);
  @Output() elementClicked = new EventEmitter<any>();
  @Output() page = new EventEmitter<any>();
  @Output() sortChange = new EventEmitter<Sort>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private _liveAnnouncer: LiveAnnouncer) { }

  ngAfterViewInit(): void {
    this.dataSource = new MatTableDataSource<any>(this.data);
    if (!this.serverSidePagination) {
      this.dataSource.paginator = this.paginator;
    } else {
      this.dataSource.paginator = null;
    }

    this.dataSource.sort = this.sort;
    this.dataSource.filter = this.filter;
    this.dataSource.filterPredicate = this.filterPredicate;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessorFn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.dataSource = new MatTableDataSource<any>(changes.data.currentValue);
      if (!this.serverSidePagination) {
        this.dataSource.paginator = this.paginator;
      } else {
        this.dataSource.paginator = null;
      }

      this.dataSource.sort = this.sort;
      this.dataSource.filter = this.filter;
      this.dataSource.filterPredicate = this.filterPredicate;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessorFn;

      if (!this.serverSidePagination && this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    }

    if (changes.filter) {
      this.dataSource.filter = changes.filter.currentValue;
    }
    if (changes['length'] && this.serverSidePagination && this.paginator) {
      this.paginator.length = this.length;
    }

    if (changes['pageSize'] && this.serverSidePagination && this.paginator) {
      this.paginator.pageSize = this.pageSize;
    }

    if (changes['pageIndex'] && this.serverSidePagination && this.paginator) {
      this.paginator.pageIndex = this.pageIndex;
    }
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
    this.sortChange.emit(sortState);

    if (this.customSortColumns.includes(sortState.active) && this.sort) {
      setTimeout(() => {
        if (this.sort) {
          this.sort.active = null;
          this.sort.direction = '';
          this.dataSource.sort = null;
          this.dataSource.sort = this.sort;
        }
      }, 10);
    }
  }

  sortingDataAccessorFn(item: any, property: string): string | number {
    if (item[property]?.codigo) {
      return item[property].codigo;
    }
    if (item[property]?.label) {
      return item[property].label;
    }
    return item[property];
  }

  filterPredicate(data: any, filter: string) {
    const accumulator = (currentTerm: any, key: any) => {
      return key === 'status' ? currentTerm + data[key].label : currentTerm + data[key];
    };
    // 1. Transforma o objeto em uma string concatenada com todos os valores das colunas
    const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
    // 2. Tira espaços em branco e transforma em minúsculo o filtro
    const transformedFilter = filter.trim().toLowerCase();
    // 3. Retorna true se a string concatenada contém o filtro
    return dataStr.indexOf(transformedFilter) !== -1;
  }
  addHttpPrefix(url: string) {
    if (!url) return url;
    if (url.startsWith("http")) return url;
    else return "//" + url
  }
  removeHttpPrefix(url: string) {
    if (!url) return url;
    if (url.startsWith("https://")) return url.substring(8);
    if (url.startsWith("http://")) return url.substring(7);
    return url
  }
  elementRowSelected(row) {
    this.elementClicked.emit(row);
  }
  onPageChange(event: any) {
    if (this.serverSidePagination) {
      this.page.emit(event);
    }
  }

  getRowTooltip(row: any): string {
    if (!this.rowTooltip) return '';

    if (typeof this.rowTooltip === 'function') {
      return this.rowTooltip(row);
    }

    return this.rowTooltip;
  }
}
